import { Theme, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
    rowContainer: {
        backgroundColor: theme.palette.secondary.light,
    },
}))

export default useStyles
